import { getCustomComponent } from "./customComponentMap";
import type { BaseComponentProps } from "../../types";

import type { CustomComponentSchemaProps } from "@/features/integrations/types";

type CustomComponentRendererProps = BaseComponentProps & CustomComponentSchemaProps;

export function CustomComponentRenderer({
  name,
  ...rest
}: CustomComponentRendererProps) {
  const Component = getCustomComponent(name);

  if (!Component) {
    console.warn(`Custom component "${name}" not registered`);
    return null;
  }

  return <Component {...rest} />;
}
